import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useIsCalendarStartFromAvailableMonth } from "./hooks/use-is-calendar-start-from-available-month";

export const QuestionIsCalendarStartFromAvailableMonth = () => {
	const { isEdited, hasError, isCalendarStartFromAvailableMonth, onSetIsCalendarStartFromAvailableMonth } =
		useIsCalendarStartFromAvailableMonth();

	const title = "宿泊カレンダーの初期表示を空室のある直近の月にする";
	const guide =
		"有効にすると、カレンダーの初期表示時に予約可能な日程がある最も近い月が最初に表示されます。<br />予約可能な日程が先の月にある施設で、ゲストが空きを見つけやすくなります。<br /><br />" +
		"なお、当該月から最大12ヶ月分まで空き状況を確認します。その範囲のいずれの月にも予約可能な日がない場合は、確認範囲の最終月が表示されます（例：基準月が4月なら翌3月）。";

	const label = "宿泊カレンダーの初期表示を空室のある直近の月にする";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<CheckboxField
					value={isCalendarStartFromAvailableMonth.value}
					label={label}
					handleChange={onSetIsCalendarStartFromAvailableMonth}
				/>
			}
		/>
	);
};

QuestionIsCalendarStartFromAvailableMonth.displayName = "QuestionIsCalendarStartFromAvailableMonth";
